import React from 'react';
import { observer } from 'mobx-react';
import CssIntegerNumberInput from './baseInputs/CssIntegerNumberInput';
const extractGridAreaProperty = (object, property) => {
  let value = object[property];
  if (value === 'auto') {
    value = '0';
  }
  return value;
};
const GridAreaEdit = observer(({
  id,
  value,
  setCssProperty,
  htmlElement
}) => {
  const getIdOrWrapperId = () => {
    const wrapperId = htmlElement.getAttribute('data-custom-css-cover-id');
    if (wrapperId) {
      return wrapperId;
    }
    return id;
  };
  const setProperty = (field, value) => {
    const wrapperId = htmlElement.getAttribute('data-custom-css-cover-id');
    if (wrapperId) {
      const wrapperID = wrapperId;
      setCssProperty(wrapperID, field, value);
    } else {
      setCssProperty(id, field, value);
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "single-css-property grid-area-property"
  }, /*#__PURE__*/React.createElement("span", {
    className: "css-property-name"
  }, "Posizione box"), /*#__PURE__*/React.createElement("span", {
    className: "css-values single-row-css-values"
  }, /*#__PURE__*/React.createElement("span", {
    className: "single-row-css-value"
  }, /*#__PURE__*/React.createElement(CssIntegerNumberInput, {
    value: extractGridAreaProperty(value[getIdOrWrapperId()], 'grid-row-start'),
    setValue: v => {
      setProperty('grid-row-start', v);
    },
    title: 'Riga iniziale'
  })), /*#__PURE__*/React.createElement("span", {
    className: "single-row-css-value"
  }, /*#__PURE__*/React.createElement(CssIntegerNumberInput, {
    value: extractGridAreaProperty(value[getIdOrWrapperId()], 'grid-row-end'),
    setValue: v => {
      setProperty('grid-row-end', v);
    },
    title: 'Riga finale'
  })), /*#__PURE__*/React.createElement("span", {
    className: "single-row-css-value"
  }, /*#__PURE__*/React.createElement(CssIntegerNumberInput, {
    value: extractGridAreaProperty(value[getIdOrWrapperId()], 'grid-column-start'),
    setValue: v => {
      setProperty('grid-column-start', v);
    },
    title: 'Colonna iniziale'
  })), /*#__PURE__*/React.createElement("span", {
    className: "single-row-css-value"
  }, /*#__PURE__*/React.createElement(CssIntegerNumberInput, {
    value: extractGridAreaProperty(value[getIdOrWrapperId()], 'grid-column-end'),
    setValue: v => {
      setProperty('grid-column-end', v);
    },
    title: 'Colonna finale'
  }))));
});
export default GridAreaEdit;